export const INPUT = 'INPUT'
export const SELECT = 'SELECT'
export const TEXTAREA = 'TEXTAREA'
export const BUTTON = 'BUTTON'
